import { RT_DynamicText } from "../types";

// ---------------------------------------------------------------------- //

type Props = { leaf: RT_DynamicText };

export function LeafRenderStatic({ leaf }: Props) {
  let children: React.ReactNode = leaf.text;

  // bold
  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  // italic
  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  return <span>{children}</span>;
}
